import codify from './codify';
import videoify from './videoify';
import smilify from './smilify';
import mathify from './mathify';

export default function (options) {
  smilify(options);
  codify(options);
  videoify(options);
  mathify(options);
}
